import RemoteVideoComponent from "../../components/RemoteVideoComponent";
import React, { useContext } from "react";
import { TwoColumn, TwoRow } from "../../core/layouts";
import variables from "../../themes/base/styles/variables";
import { Text, Tooltip } from "react_reusable_components";
import { AuditContext } from "../../globalContext/ManageAudit/AuditProvider";
import SingleQuestionnaireContainer from "../../containers/SingleQuestionnaireContainer";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import { useIntl } from "react-intl";
import { RemoteAuditContext } from "../../globalContext/remoteAudit/remoteAuditProvider";
import useResponsive from "core/hooks/useResponsive";

const RemoteAuditQuestionnaireContainerStyle = {
  mainContainerStyle: {
    backgroundColor: variables.grey5,
    padding: variables.paddingMedium,
    paddingTop: variables.paddingSmallLG,
    gap: variables.gapSmall,
    position: "relative",
    overflow: "unset",
    maxWidth: "100vw",
  },
  topLabelWrapperStyle: {
    gap: variables.gapSmaller,
    alignItems: "center",
  },
  labelStyle: {
    fontWeight: variables.fontWeightBold,
    fontSize: variables.fontSizeXlarge,
    lineHeight: variables.lineHeightXxlarge,
  },
  questionnaireNameStyle: {
    fontWeight: variables.fontWeightBold,
    fontSize: variables.fontSizeNormal,
    lineHeight: variables.lineHeightSmall,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "calc(100vw - 14rem)",
  },
  labelRightWrapperStyle: {
    borderLeft: `1px solid ${variables.grey4}`,
    paddingLeft: variables.paddingSmall,
  },
  sectionWrapperStyle: {
    width: variables.fullWidth,
    gap: variables.gapLarge2,
    height: variables.fullHeight,
    overflow: "unset",
  },
  sectionStyle: {
    width: variables.remoteAuditSectionWidth,
    height: variables.fullHeight,
  },
  bottomSectionStyle: {
    height: variables.remoteAuditBottomContainerHeight,
  },
  bottomSectionStyleForCallEnded: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  callLeftTextStyle: {
    fontSize: variables.fontSizeXxxLarge,
    fontWeight: variables.fontWeightBold,
  },
};
const RemoteAuditQuestionnaireContainer = () => {
  const [auditState] = useContext(AuditContext);
  const intl = useIntl();

  const [remoteAuditState] = useContext(RemoteAuditContext);
  const responsive = useResponsive();

  return (
    <TwoRow
      style={RemoteAuditQuestionnaireContainerStyle.mainContainerStyle}
      topSection={
        <TwoColumn
          style={RemoteAuditQuestionnaireContainerStyle.topLabelWrapperStyle}
          leftSection={
            <Text
              type="secondary"
              style={RemoteAuditQuestionnaireContainerStyle.labelStyle}
            >
              {getLocalizedMessage(intl, "e-audit.label")}
            </Text>
          }
          rightSectionStyle={
            RemoteAuditQuestionnaireContainerStyle.labelRightWrapperStyle
          }
          rightSection={
            <Text
              type="secondary"
              style={
                RemoteAuditQuestionnaireContainerStyle.questionnaireNameStyle
              }
            >
              <Tooltip
                placement="bottomLeft"
                title={auditState?.auditDetail?.questionnaireName}
              >
                {auditState?.auditDetail?.questionnaireName}
              </Tooltip>
            </Text>
          }
        />
      }
      bottomSectionStyle={{
        ...RemoteAuditQuestionnaireContainerStyle.bottomSectionStyle,
        ...(remoteAuditState?.isCallEnded &&
          RemoteAuditQuestionnaireContainerStyle.bottomSectionStyleForCallEnded),
      }}
      bottomSection={
        remoteAuditState?.isCallEnded ? (
          <Text
            style={RemoteAuditQuestionnaireContainerStyle.callLeftTextStyle}
            type="secondary"
          >
            {getLocalizedMessage(intl, "remoteAudit.callEnded")}
          </Text>
        ) : (
          <TwoColumn
            style={{
              ...RemoteAuditQuestionnaireContainerStyle.sectionWrapperStyle,
              ...(!responsive?.isSm && { flexDirection: "column" }),
            }}
            leftSectionStyle={{
              ...RemoteAuditQuestionnaireContainerStyle.sectionStyle,
              ...(!responsive?.isSm && { width: "100%" }),
            }}
            leftSection={<RemoteVideoComponent />}
            rightSectionStyle={{
              ...RemoteAuditQuestionnaireContainerStyle.sectionStyle,
              ...(!responsive?.isSm && { width: "100%" }),
            }}
            rightSection={<SingleQuestionnaireContainer />}
          />
        )
      }
    />
  );
};

export default RemoteAuditQuestionnaireContainer;
